/*global define*/

define(function (require) {
    'use strict';

    function maStringColumn() {
        return {
            restrict: 'E',
            scope: {
                value: '&'
            },
            template: '<span>{{ value() }}</span>'
        };
    }

    maStringColumn.$inject = [];

    return maStringColumn;
});



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./src/javascripts/ng-admin/Crud/column/maStringColumn.js
 **/